export default __webpack_public_path__ + "static/media/pot4.91e9f8b1.svg";